export const normalizeFreeTextValue = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map((v) =>
      typeof v === 'string' ? v.toLowerCase().trim() : v
    ) as T;
  }

  return (typeof value === 'string' ? value.toLowerCase().trim() : value) as T;
};
